export enum StudentProfileStatus {
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  ACTIVE = 'ACTIVE',
  BANNED = 'BANNED',
}

export enum UserRole {
  ANONYMOUS = 'ANONYMOUS',
  STUDENT = 'STUDENT',
  MENTOR = 'MENTOR',
  ADMIN = 'ADMIN',
}

export enum AcademicYear {
  BACHELOR_1 = 'Bachelor, 1',
  BACHELOR_2 = 'Bachelor, 2',
  BACHELOR_3 = 'Bachelor, 3',
  BACHELOR_4 = 'Bachelor, 4',
  SPECIALIST_1 = 'Specialist, 1',
  SPECIALIST_2 = 'Specialist, 2',
  SPECIALIST_3 = 'Specialist, 3',
  SPECIALIST_4 = 'Specialist, 4',
  SPECIALIST_5 = 'Specialist, 5',
  MASTER_1 = 'Master, 1',
  MASTER_2 = 'Master, 2',
  POSTGRADUATE_1 = 'Postgraduate, 1',
  POSTGRADUATE_2 = 'Postgraduate, 2',
  POSTGRADUATE_3 = 'Postgraduate, 3',
  POSTGRADUATE_4 = 'Postgraduate, 4',
  POSTGRADUATE_5 = 'Postgraduate, 5',
}

export enum ICPCType {
  SWERC = 'SWERC',
  NWERC = 'NWERC',
  CERC = 'CERC',
  SEERC = 'SEERC',
  NER = 'NER',
  EUC = 'EUC',
  NAC = 'NAC',
  WF = 'WF',
  OTHER = 'OTHER',
}
